import { createFileRoute, Link } from "@tanstack/react-router";
import * as m from "~/paraglide/messages";

export const Route = createFileRoute("/barrierefreiheit")({
  component: BarrierefreiheitPage,
});

function BarrierefreiheitPage() {
  return (
    <div
      className="mx-auto max-w-3xl px-6 py-16"
      style={{ color: "var(--text)" }}
    >
      <h1
        className="text-3xl font-bold tracking-tight"
        style={{ color: "var(--text)" }}
      >
        {m.a11y_statement_title()}
      </h1>
      <p
        className="mt-2 text-sm"
        style={{ color: "var(--text-muted)" }}
      >
        {m.a11y_statement_subtitle()}
      </p>

      <p
        className="mt-6 text-sm leading-relaxed"
        style={{ color: "var(--text-secondary)" }}
      >
        {m.a11y_statement_intro()}
      </p>

      {/* Compliance status */}
      <section className="mt-10">
        <h2 className="text-xl font-semibold" style={{ color: "var(--text)" }}>
          {m.a11y_statement_status_title()}
        </h2>
        <p
          className="mt-3 text-sm leading-relaxed"
          style={{ color: "var(--text-secondary)" }}
          dangerouslySetInnerHTML={{ __html: m.a11y_statement_status_text() }}
        />
      </section>

      {/* Accessible areas */}
      <section className="mt-10">
        <h2 className="text-xl font-semibold" style={{ color: "var(--text)" }}>
          {m.a11y_statement_accessible_title()}
        </h2>
        <ul
          className="mt-3 list-disc space-y-1.5 pl-5 text-sm leading-relaxed"
          style={{ color: "var(--text-secondary)" }}
        >
          <li>{m.a11y_statement_accessible_keyboard()}</li>
          <li>{m.a11y_statement_accessible_skip_nav()}</li>
          <li>{m.a11y_statement_accessible_screen_reader()}</li>
          <li>{m.a11y_statement_accessible_motion()}</li>
          <li>{m.a11y_statement_accessible_contrast()}</li>
          <li>{m.a11y_statement_accessible_forms()}</li>
          <li>{m.a11y_statement_accessible_semantic()}</li>
          <li>{m.a11y_statement_accessible_dnd()}</li>
          <li>{m.a11y_statement_accessible_focus()}</li>
        </ul>
      </section>

      {/* Known limitations */}
      <section className="mt-10">
        <h2 className="text-xl font-semibold" style={{ color: "var(--text)" }}>
          {m.a11y_statement_limitations_title()}
        </h2>
        <ul
          className="mt-3 list-disc space-y-1.5 pl-5 text-sm leading-relaxed"
          style={{ color: "var(--text-secondary)" }}
        >
          <li>{m.a11y_statement_limitations_pdf()}</li>
          <li>{m.a11y_statement_limitations_extension()}</li>
          <li>{m.a11y_statement_limitations_ai_panels()}</li>
        </ul>
      </section>

      {/* Feedback and contact */}
      <section className="mt-10">
        <h2 className="text-xl font-semibold" style={{ color: "var(--text)" }}>
          {m.a11y_statement_feedback_title()}
        </h2>
        <p
          className="mt-3 text-sm leading-relaxed"
          style={{ color: "var(--text-secondary)" }}
        >
          {m.a11y_statement_feedback_text()}
        </p>
        <address
          className="mt-3 text-sm not-italic leading-relaxed"
          style={{ color: "var(--text-secondary)" }}
        >
          {m.a11y_statement_feedback_email_label()}{" "}
          <a
            href="mailto:accessibility@alchema.eu"
            className="underline underline-offset-2"
            style={{ color: "var(--accent)" }}
          >
            accessibility@alchema.eu
          </a>
          <br />
          {m.a11y_statement_feedback_post()}
        </address>
        <p
          className="mt-3 text-sm leading-relaxed"
          style={{ color: "var(--text-secondary)" }}
        >
          {m.a11y_statement_feedback_response()}
        </p>
      </section>

      {/* Enforcement */}
      <section className="mt-10">
        <h2 className="text-xl font-semibold" style={{ color: "var(--text)" }}>
          {m.a11y_statement_enforcement_title()}
        </h2>
        <p
          className="mt-3 text-sm leading-relaxed"
          style={{ color: "var(--text-secondary)" }}
        >
          {m.a11y_statement_enforcement_text()}
        </p>
        <address
          className="mt-4 text-sm not-italic leading-relaxed"
          style={{ color: "var(--text-secondary)" }}
        >
          <strong style={{ color: "var(--text)" }}>
            {m.a11y_statement_enforcement_authority()}
          </strong>
          <br />
          {m.a11y_statement_enforcement_street()}
          <br />
          {m.a11y_statement_enforcement_city()}
          <br />
          {m.a11y_statement_feedback_email_label()}{" "}
          <a
            href="mailto:info@mlbf.bund.de"
            className="underline underline-offset-2"
            style={{ color: "var(--accent)" }}
          >
            info@mlbf.bund.de
          </a>
          <br />
          Internet:{" "}
          <a
            href="https://www.mlbf.bund.de"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-2"
            style={{ color: "var(--accent)" }}
          >
            https://www.mlbf.bund.de
          </a>
        </address>
      </section>

      {/* Creation date */}
      <section className="mt-10">
        <h2 className="text-xl font-semibold" style={{ color: "var(--text)" }}>
          {m.a11y_statement_creation_title()}
        </h2>
        <p
          className="mt-3 text-sm leading-relaxed"
          style={{ color: "var(--text-secondary)" }}
        >
          {m.a11y_statement_creation_text()}
        </p>
        <p
          className="mt-1 text-sm leading-relaxed"
          style={{ color: "var(--text-secondary)" }}
        >
          {m.a11y_statement_creation_method()}
        </p>
      </section>

      {/* Date */}
      <p
        className="mt-10 text-sm"
        style={{ color: "var(--text-muted)" }}
      >
        {m.a11y_statement_date()}
      </p>

      {/* VPAT link */}
      <section className="mt-10">
        <Link
          to="/vpat"
          className="text-sm underline underline-offset-2"
          style={{ color: "var(--accent)" }}
        >
          VPAT 2.5 Conformance Report (EN)
        </Link>
      </section>

      {/* Back to home */}
      <div className="mt-16">
        <Link
          to="/"
          className="text-sm underline underline-offset-2"
          style={{ color: "var(--accent)" }}
        >
          {m.a11y_statement_back_home()}
        </Link>
      </div>
    </div>
  );
}
